import { render, staticRenderFns } from "./vue-aplayer.vue?vue&type=template&id=55d223ff&"
import script from "./vue-aplayer.vue?vue&type=script&lang=js&"
export * from "./vue-aplayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports